import Price, { Props as PriceProps } from '@repo/ui/components/price'
import { cn } from '@repo/ui/lib/utils'
import { FunctionComponent } from 'react'

interface Props extends PriceProps {
  discount?: number
}

const PriceWithDiscount: FunctionComponent<Props> = ({ amount, discount, currencyCode, className, as = 'div' }) => {
  const Type = as

  return (
    <Type className={cn('inline-flex gap-1 text-right', className)}>
      <Price amount={amount + (discount || 0)} currencyCode={currencyCode} as={(discount || 0) > 0 ? 'del' : 'span'} />
      {(discount || 0) > 0 && <Price amount={amount} currencyCode={currencyCode} as='span' />}
    </Type>
  )
}

export default PriceWithDiscount
